<template>
  <div class="animated">
    <v-client-table
      :columns="columns"
      :data="analyses"
      :options="options"
      :theme="theme"
      id="analysis-table"
      class="w-100"
    >
      <span slot="sample_type" slot-scope="{ row }">
        {{ row.analyte.sample_type.name }}
      </span>
      <span slot="analyte" slot-scope="{ row }">
        {{ row.analyte.abbrev }}
      </span>
      <span slot="name" slot-scope="{ row }">
        <a :href="`#/analysis/${row.id}`" class="btn-link">{{ row.name }}</a>
      </span>
      <span slot="modus_name" slot-scope="{ row }">
        <a :href="`#/analysis/${row.id}`" class="btn-link">{{
          row.modus_name
        }}</a>
      </span>
      <span slot="extraction_method" slot-scope="{ row }">
        {{ row.extraction_method }}
      </span>
      <span slot="measurement_method" slot-scope="{ row }">
        {{ row.measurement_method }}
      </span>
      <span slot="actions" slot-scope="{ row }">
        <a
          class="btn btn-info px-1 py-0 text-white mr-1"
          :href="`#/analysis/${row.id}`"
        >
          <i class="fa fa-eye" />
        </a>
        <a
          class="btn btn-warning px-1 py-0 text-white mr-1"
          :href="`#/analysis/${row.id}/edit`"
        >
          <i class="fa fa-pencil" />
        </a>
        <a
          class="btn btn-danger px-1 py-0 text-white mr-1"
          @click="showDeleteModal(row.id)"
        >
          <i class="fa fa-trash" />
        </a>
      </span>
    </v-client-table>
  </div>
</template>

<script>
import Vue from "vue";
import { ClientTable, Event } from "vue-tables-2";

Vue.use(ClientTable);

export default {
  name: "AnalysisTable",
  components: {
    ClientTable,
    Event
  },
  props: {
    analyses: {
      type: Array
    },
    show_columns: {
      type: Array,
      default: () => [
        "sample_type",
        "analyte",
        "name",
        "modus_name",
        "extraction_method",
        "measurement_method",
        "actions"
      ]
    }
  },
  data() {
    return {
      columns: this.show_columns,
      data: this.analysis,
      options: {
        headings: {
          sample_type: "Sample Type",
          analyte: "Analyte",
          name: "Analysis Name",
          modus_name: "MODUS",
          extraction_method: "Extraction Method",
          measurement_method: "Measurement Method",
          actions: "actions"
        },
        sortable: [
          "sample_type",
          "analyte",
          "name",
          "modus_name",
          "extraction_method",
          "measurement_method"
        ],
        filterable: [
          "sample_type",
          "analyte",
          "name",
          "modus_name",
          "extraction_method",
          "measurement_method"
        ],
        sortIcon: {
          base: "fa",
          up: "fa-sort-asc",
          down: "fa-sort-desc",
          is: "fa-sort"
        },
        pagination: {
          chunk: 5,
          edge: false,
          nav: "scroll"
        }
      },
      useVuex: false,
      theme: "bootstrap4",
      template: "default"
    };
  },
  methods: {
    showDeleteModal(id) {
      this.$bvModal
        .msgBoxConfirm(
          "You are about to remove this analysis. Do you want to continue?",
          {
            title: "Are you sure?",
            modalClass: ["modal-danger"],
            size: "sm",
            okVariant: "danger",
            okTitle: "YES",
            cancelTitle: "NO",
            footerClass: "p-2",
            centered: true
          }
        )
        .then(() => {
          this.$emit("deleteAnalysis", id);
        });
    }
  }
};
</script>
